import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAllExistingUsersQuery, useDeleteUserMutation, useStatusChangeMutation } from '../../../Store/Apis/manageUserApi';
import Loader from '../../../Components/Loader/Loader';
import Error from '../../../Components/Error/Error';
import { Table } from 'antd';
import { useRolesQuery } from '../../../Store/Apis/rolePermissionApi';
import { useSelector } from 'react-redux';

const ExistingUsersPage = () => {
  const user = useSelector((state) => state.auth.user);
  const [sortFilter, setSortFilter] = useState({ keyword: '', keynum: '', keyID: '', outletID: ''});
  const allExistingUser = useAllExistingUsersQuery(sortFilter);

  const roleApi = useRolesQuery();

  // Status Change
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useStatusChangeMutation();
  const handleChangeStatus = () => {
    changeStatus(selectedStatus).then((res) => {
      console.log(res);
      setSelectedStatus(null);
    });
  };

  // Delete User
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteUser] = useDeleteUserMutation();
  const handleDelete = () => {
    deleteUser(selectedRecord).then((res) => {
      console.log(res);
      setSelectedRecord(null);
    });
  };


  useEffect(() => {
    if (user.role !== 'superAdmin') {
      setSortFilter({
        ...sortFilter,
        outletID: user.outletID
      });
    }    
  }, []);


  // Table Columns
  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      render: (_, __, index) => index + 1,
      width: '5%',
    },
    {
      title: 'Name',
      dataIndex: 'username',
      key: 'username',
      sorter: (a, b) => a.username.localeCompare(b.username),
      render: (text, record) => (
        <>
          <strong>{text}</strong>
          <br />
          <span>{record.roleName}</span>
        </>
      ),
    },
    // {
    //   title: 'Outlet',
    //   dataIndex: 'outletName',
    //   key: 'outletName',
    // },
    {
      title: 'Contact',
      dataIndex: 'contact',
      key: 'contact',
      render: (_, record) => (
        <>
          {record.phone}
          <br />
          {record.email}
        </>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive, record) => (
        <button
          type="button"
          className={`btn badge badge-xs ${isActive ? 'badge-success' : 'badge-danger'} fw-600 text-xs mb-0`}
          onClick={() => setSelectedStatus({ keyID: record.id, isActive: isActive ? 0 : 1 })}
        >
          {isActive ? 'Active' : 'Deactivated'}
        </button>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Link to={`/manage-users/edit-user?id=${record.id}`} className="mx-1 badge badge-xs badge-warning fw-600 text-xs">
            Edit
          </Link>
          <button
            type="button"
            className="btn ms-2 badge badge-xs badge-danger text-xs fw-600 mb-0"
            onClick={() => setSelectedRecord(record.id)}
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="row align-items-center justify-content-between mb-3">
        <div className="col">
          <h5 className="fw-500 text-white">Existing Users</h5>
        </div>
        <div className="col-auto">
          <Link to={'/manage-users/add-user'} className="btn btn-icon btn-3 btn-white text-primary mb-0">
            <i className="fa fa-plus me-2"></i> Add New User
          </Link>
        </div>
      </div>

      <div className="card">
        <div className="card-header p-4">
          <div className="row">
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Name and Email"
                value={sortFilter?.keyword || ''}
                onChange={(e) => setSortFilter({ ...sortFilter, keyword: e.target.value })}
              />
            </div>
            <div className="col-md-6">
              <select
                className="form-select"
                disabled={roleApi.isError || !roleApi.isSuccess}
                value={sortFilter?.keynum || ''}
                onChange={(e) => setSortFilter({ ...sortFilter, keynum: e.target.value })}
              >
                <option value="">All Users</option>
                {roleApi?.data?.data?.map((elem) => (
                  <option key={elem.roleID} value={elem.roleID}>
                    {elem.roleName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="card-body p-0">
          {allExistingUser.isError && <Error />}
          {allExistingUser.isLoading && <Loader height="500px" />}
          {allExistingUser.isSuccess && (
            <Table
              columns={columns}
              dataSource={allExistingUser?.data?.data || []}
              rowKey="id"
              pagination={{ pageSize: 10 }}
              bordered
            />
          )}
        </div>
      </div>

      {/* Status Change Modal */}
      <Modal show={!!selectedStatus} onHide={() => setSelectedStatus(null)} size="sm" centered>
        <Modal.Body className="text-center p-4">
          <h5>Are you sure you want to change status?</h5>
          <div className="buttons d-flex gap-3 justify-content-center">
            <button className="btn btn-danger btn-sm mb-0" onClick={() => setSelectedStatus(null)}>
              Cancel
            </button>
            <button className="btn btn-primary btn-sm mb-0" onClick={handleChangeStatus}>
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Delete Modal */}
      <Modal show={!!selectedRecord} onHide={() => setSelectedRecord(null)} size="sm" centered>
        <Modal.Body className="text-center p-4">
          <h5>Are you sure you want to delete the user?</h5>
          <div className="buttons d-flex gap-3 justify-content-center">
            <button className="btn btn-danger btn-sm mb-0" onClick={() => setSelectedRecord(null)}>
              Cancel
            </button>
            <button className="btn btn-primary btn-sm mb-0" onClick={handleDelete}>
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ExistingUsersPage;
